import Home from "./pages/Home";
import UserImpersonation from "./pages/UserImpersonation";
import AccountSelect from "./pages/AccountSelect";
import InformationHub from "./pages/InformationHub";
import ErrorPage from "./pages/ErrorPage";
import ConsultantAccountSelect from "./pages/ConsultantAccountSelect";
import LeiTerms from "./pages/LeiTerms";
import Documents from "./pages/Documents";
import DocumentSelect from "./pages/DocumentSelect";
import Privacy from "./pages/Privacy";
import Processing from "./pages/Processing";
import { documentTypes } from "./constants/documentConstants";
import Administration from "./pages/Administration";
import { baseRoute as safetynestBaseRoute } from "./safetynest/routes";
import SafetynestIndex from "./safetynest/SafetynestIndex";
import HubCategories from "./pages/KnowledgeHub/HubCategories";
import HubCategory from "./pages/KnowledgeHub/HubCategory";
import HubItemDetails from "./pages/KnowledgeHub/HubItemDetails";
import Login from "./pages/Login";
import Hello from "./pages/Hello";
import EditUser from "./pages/EditUser";
import AddUser from "./pages/AddUser";
import ResourceNest from "./resourcenest/ResourceNest";
import KnowledgeBank from "./knowledgebank/KnowledgeBank";
import PrimaryCategories from "./knowledgebank/PrimaryCategories";
import PrimaryCategory from "./knowledgebank/PrimaryCategory";
import SubCategory from "./knowledgebank/SubCategory";
import Article from "./knowledgebank/Article";
import HRSEvent from "./knowledgebank/Event";
import Events from "./knowledgebank/Events";
import TrustCentreHome from "./pages/TrustCentre/TrustCentreHome";
import PrivacyPolicy from "./pages/TrustCentre/policies/PrivacyPolicy";
import CookiePolicy from "./pages/TrustCentre/policies/CookiePolicy";
import TermsOfUsePolicy from "./pages/TrustCentre/policies/TermsOfUsePolicy";
import AcceptableUsePolicy from "./pages/TrustCentre/policies/AcceptableUsePolicy";
import Acknowledge from "./pages/Acknowledge";
import AcknowledgeRiskAssessment from "./safetynest/pages/nonuser/acknowledgements/AcknowledgeRiskAssessment";
import NonUserIncidentForm from "./safetynest/pages/nonuser/incidents/NonUserIncidentForm";
import NonUserActionForm from "./safetynest/pages/nonuser/actions/NonUserActionForm";

export const protectedRoutes = [
    {
        label: "Home",
        path: "/",
        exact: true,
        component: Home,
    },
    {
        label: "Knowledge Hub",
        path: "/knowledgehub/:sectionName",
        exact: true,
        component: HubCategories,
    },
    {
        label: "Knowledge Hub Category",
        path: "/knowledgehub/:sectionName/:categoryId",
        exact: true,
        component: HubCategory,
    },
    {
        label: "Knowledge Hub Category",
        path: "/knowledgehub/:sectionName/search/:searchTerm",
        exact: true,
        component: HubCategory,
    },
    {
        label: "Knowledge Hub Category",
        path: "/knowledgehub/:sectionName/:categoryId/:itemType/:itemId/:cachePage",
        exact: true,
        component: HubItemDetails,
    },
    {
        label: "User Impersonation",
        path: "/impersonate",
        component: UserImpersonation,
    },
    {
        label: "Account Select",
        path: "/account-select",
        component: AccountSelect,
    },
    {
        label: "Error",
        path: "/error",
        component: ErrorPage,
    },
    {
        label: "Information Hub",
        path: "/welcome",
        component: InformationHub,
    },
    {
        label: "Legal Expenses Insurance - Terms",
        path: "/lei",
        component: LeiTerms,
    },
    {
        label: "Consultant Account Select",
        path: "/consultant-account-select",
        component: ConsultantAccountSelect,
    },
    {
        label: "Document Manager",
        path: "/documents",
        component: DocumentSelect,
        exact: true,
    },
    {
        label: "Document Manager",
        // React Router v7 dropped regex path params (was `:documentTypeValue(1|0)`
        // in v5); the Documents component validates the value itself.
        path: `/documents/:documentTypeValue`,
        component: Documents,
    },
    {
        label: "Administration",
        path: "/administration",
        component: Administration,
    },
    {
        label: "Add User",
        path: "/add-user",
        component: AddUser,
    },
    {
        label: "Edit User",
        path: "/edit-user",
        component: EditUser,
    },
    {
        label: "Safetynest",
        path: safetynestBaseRoute,
        component: SafetynestIndex,
    },
    {
        label: "Privacy Policy",
        path: "/privacy",
        component: Privacy,
    },
    {
        label: "Processing Policy",
        path: "/processing",
        component: Processing,
    },
    {
        label: "ResourceNest",
        path: "/resourcenest/:licence",
        component: ResourceNest,
    },
    {
        label: "KnowledgeBankArticle",
        path: "/knowledge/article/:id",
        component: Article,
    },
    {
        label: "KnowledgeBankEvent",
        path: "/knowledge/event/:id",
        component: HRSEvent,
    },
    {
        label: "KnowledgeBankCategory",
        path: "/knowledge/category/:primaryCategoryName/:subCategoryName",
        component: SubCategory,
    },
    {
        exact: true,
        label: "KnowledgeBankCategory",
        path: "/knowledge/category/:primaryCategoryName",
        component: PrimaryCategory,
    },
    {
        label: "KnowledgeBankCategories",
        path: "/knowledge/categories",
        component: PrimaryCategories,
    },
    {
        label: "KnowledgeBankEvents",
        path: "/knowledge/events",
        component: Events,
    },
    {
        exact: true,
        label: "KnowledgeBank",
        path: "/knowledge",
        component: KnowledgeBank,
    },
    {
        path: "/trustcentre",
        exact: true,
        component: TrustCentreHome,
    },
    {
        path: "/trustcentre/privacy",
        exact: true,
        component: PrivacyPolicy,
    },
    {
        path: "/trustcentre/cookies",
        exact: true,
        component: CookiePolicy,
    },
    {
        path: "/trustcentre/termsofuse",
        exact: true,
        component: TermsOfUsePolicy,
    },
    {
        path: "/trustcentre/acceptableuse",
        exact: true,
        component: AcceptableUsePolicy,
    },
    {
        path: "/safetynest/acknowledge/:reference",
        exact: true,
        component: AcknowledgeRiskAssessment,
    },
    {
        path: "/acknowledge/:reference",
        exact: true,
        component: Acknowledge,
    },
];

export const publicRoutes = [
    {        
        path: "/safetynest/report-issue",
        params: {
            externalId: ':externalId'
        },
        component: NonUserActionForm,
        exact: true
    },
    {
        path: "/safetynest/report-incident",
        params: {
            externalId: ':externalId'
        },
        component: NonUserIncidentForm,
        exact: true
    },
    {
        path: "/",
        exact: true,
        component: Login,
    },
    {
        path: "/knowledge",
        component: Login,
    },
    {
        path: "/hello",
        exact: true,
        component: Hello,
    },
    {
        path: "/safetynest/acknowledge/:reference",
        exact: true,
        component: AcknowledgeRiskAssessment,
    },
    {
        path: "/acknowledge/:reference",
        exact: true,
        component: Acknowledge,
    },     
];
